module.exports = __webpack_public_path__ + "static/media/Confindustria_solo_logo.9781ae4f.png";